import serviceCalls from "../services/serviceCalls";
import axios from 'axios';
import { 
  getCountry, 
  getState, 
  handleFormStep,
  storeSavedData,
  setSavedData,
  handleSaveFormLoader,
  applicationSubmitted,
  handleFormLoader } from '../store/actions/application'
import {toastr} from 'react-redux-toastr';

export const saveFormStep = async (data) => {
    let result = await serviceCalls.post('/api/application_form', data, true);
    if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
      if(result?.message){
        if(typeof result?.message == 'string' || result?.message == null){
          return toastr.error("Application", result?.message ?? 'Failed to save.');
        }else {
          const error_keys = Object.keys(result.message);
          if (error_keys?.length > 0) {
            error_keys.map(param => {
              return toastr.error("Application", result.message[param][0]);
            })
          }
        }
      } else {
        toastr.error("Application", result?.error || result?.data?.error || "Saving step failed");
      }
    } else if (result?.status == "success") {
        return result;
    } else {
        return {};	
    }
}

export const getSavedAppData = async (body) => {
  let result = await serviceCalls.post('/api/get_application_form_data', body, true);
  if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
      // toastr.error("Application", result?.message[0] || result?.error || result?.data?.error || "Error fetching application data");
  } else if (result?.status == "success") {
      return result;
  } else {
      return {};	
  }
}

export const getSavedAppDataForAppId = async (id) => {
  let result = await serviceCalls.get('/api/get_application?id='+id, null, true);
  if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
    if(result?.message?.[0] == 'Application Mismatch'){
      window.location.href = '/apply';
    }
      // toastr.error("Application", result?.message[0] || result?.error || result?.data?.error || "Error fetching application data");
  } else if (result?.status == "success") {
      return result;
  } else {
      return {};	
  }
}



export const saveBayanApplication = data => {
  return dispatch => {
  return axios({
        method: 'post',
        headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
        url: '/ajax/app/application-data',
        data: data,
    })
    .then(res => {
      if(res.status === 200){
        // dispatch(saveAppSuccess(res.data));
        toastr.success('Bayan Application', 'Application Saved Successfully!');
        dispatch(handleFormStep('saveApp'));
      }
    })
    .catch(error => {
      toastr.error('Bayan Application', 'Save Application Failure!');
      // dispatch(createUserFailure(error.response && error.response.data))
    })
    .finally(() => dispatch(handleSaveFormLoader(false)));
  }
}



export const getConfirmationData = (appId) => {
  return dispatch => {
    return axios.get('ajax/app/application-data?appid=' + appId)
      .then(response => {
        let data = response.data
        data.data.stepCompleted = "confirmation" 
        dispatch(setSavedData(data))
        // dispatch(handleFormStep('confirmation'));
      })
      .catch(error => {
        // console.log(error)
      })
  }
}

// export const setConfirmationDataLocally = (data) => {
//   return dispatch => {
//     dispatch(saveStepSuccess(data));
//     dispatch(handleFormStep(data.next_step));
//     dispatch(storeSavedData({ data: data, step: data.completed_step }));
//     dispatch(handleFormLoader(false))
//   }
// }


export const setConfirmationData = (data, cb) => {
  return dispatch => {
    // dispatch(setFormLoader(true));
    return axios({
      method: 'post',
      headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
      url: '/saveApplicationSteps',
      data: data,
    })
      .then(res => {
        if (res.status === 200) {
          // dispatch(saveStepSuccess(res.data));
          dispatch(handleFormStep(data.next_step));
          dispatch(storeSavedData({ data: data, step: data.completed_step }));
          toastr.success('Confirmation', 'Changes Saved Successfully');
          dispatch(handleFormLoader(false));
          cb();
        }
      })
      .catch(error => {
        cb(false);
      })
  }
}

export const getCountries = () => {
  return dispatch => {
    return axios.get('/ajax/getCountriesWithNameId')
    .then(response => {
      dispatch(getCountry(response.data))
    })
    .catch(error => {
      // console.log(error)
    })
  }
}

export const getStates = () => {
  return dispatch => {
    return axios.get('/ajax/get_started/getDataFor/states')
    .then(response => {
      dispatch(getState(response.data))
    })
    .catch(error => {
      // console.log(error)
    })
  }
}
